import star4Svg from '../../../assets/icons/star-4.svg';
import star5Svg from '../../../assets/icons/star-5.svg';

interface NightSkyOverlayProps {
  className?: string;
}

/**
 * Night Sky Overlay
 *
 * Renders decorative stars and gradient glow effects for the night period.
 * Positioned absolutely within the background container.
 * Only mounted when period === 'night'.
 *
 * Stars are positioned within a fixed-width (430px) centered container
 * to match the Figma design frame at all viewport widths.
 *
 * Responsive positioning:
 * - Mobile (< sm): Reduced top positions to avoid overlapping filter bar
 * - Desktop (sm+): Original Figma positions (aligned with 160px mascot)
 */
export default function NightSkyOverlay({ className }: NightSkyOverlayProps) {
  return (
    <div
      className={`absolute inset-0 pointer-events-none overflow-hidden ${className ?? ''}`}
      aria-hidden="true"
    >
      {/* Gradient glow ellipses - atmospheric background effect */}
      {/* Ellipse32 (lower glow): centered, top ~30%, 696x186px */}
      <div
        className="absolute left-1/2 -translate-x-1/2 sm:!top-[149px]"
        style={{
          top: '104px',
          width: '696px',
          height: '186px',
          borderRadius: '50%',
          background: 'radial-gradient(ellipse, rgba(70,70,255,0.3) 0%, transparent 70%)',
          filter: 'blur(40px)',
        }}
      />
      {/* Ellipse31 (upper glow): centered, top ~37%, 696x218px */}
      <div
        className="absolute left-1/2 -translate-x-1/2 sm:!top-[187px]"
        style={{
          top: '137px',
          width: '696px',
          height: '218px',
          borderRadius: '50%',
          background: 'radial-gradient(ellipse, rgba(70,70,255,0.25) 0%, transparent 70%)',
          filter: 'blur(40px)',
        }}
      />

      {/* Star container — fixed 430px width, centered, matching Figma frame */}
      <div
        className="absolute left-1/2 -translate-x-1/2"
        style={{ top: 0, width: '430px', height: '500px' }}
      >
        {/* Star 7: star-5.svg (5-pointed), 13x13, at (98, 118.07) */}
        <img
          src={star5Svg}
          alt=""
          className="absolute sm:!top-[118px]"
          style={{ left: '22.8%', top: '75px', width: '13px', height: '13px' }}
        />

        {/* Star 8: star-5.svg (5-pointed), 13x13, at (353.82, 185) */}
        <img
          src={star5Svg}
          alt=""
          className="absolute sm:!top-[185px]"
          style={{ left: '82.3%', top: '140px', width: '13px', height: '13px' }}
        />

        {/* Star 4: star-4.svg (4-pointed), 10x10, at (334, 115) */}
        <img
          src={star4Svg}
          alt=""
          className="absolute sm:!top-[115px]"
          style={{ left: '77.7%', top: '73px', width: '10px', height: '10px' }}
        />

        {/* Star 1: star-4.svg (4-pointed), 10x10, at (44, 158) */}
        <img
          src={star4Svg}
          alt=""
          className="absolute sm:!top-[158px]"
          style={{ left: '10.2%', top: '113px', width: '10px', height: '10px' }}
        />

        {/* Star 5: star-4.svg (4-pointed), 6x6, at (385, 151) */}
        <img
          src={star4Svg}
          alt=""
          className="absolute sm:!top-[151px]"
          style={{ left: '89.5%', top: '106px', width: '6px', height: '6px' }}
        />

        {/* Star 3: star-4.svg (4-pointed), 6x6, at (101, 196) */}
        <img
          src={star4Svg}
          alt=""
          className="absolute sm:!top-[196px]"
          style={{ left: '23.5%', top: '145px', width: '6px', height: '6px' }}
        />
      </div>
    </div>
  );
}
